import React from 'react'
import { connect } from "react-redux"
import { withRouter } from 'react-router'
import { setTitle, setUser } from "../../actions"
import { agreeToTermsConditions } from '../../actions/termsConditions'

import './styles/TermsContentStyles.scss';

const saveStyle = {
	'zIndex': 2,
	'position': 'relative'
};

@connect((store) => {
	return { User: store.User.User, app: store.app }
})


class terms_conditions extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			"saved": false,
		}
		this.agreeToTC = this.agreeToTC.bind(this);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const { router } = this.props;
		if (prevProps.User.terms_conditions !== this.props.User.terms_conditions) {
			console.log('Terms and condition update change');
			var url_string = window.location.href;
			var url = new URL(url_string);
			var redirectUrl = (url.searchParams.has('redirect')) ? '/onboarding?redirect='+url.searchParams.get('redirect'): '/onboarding';
			console.log(redirectUrl);
			router.replace(redirectUrl);
		}
	}

	componentWillMount() {
		const { User, dispatch, router, route } = this.props;
		if (User.terms_conditions === true) {
			this.setState({ "saved": true });
		}
		dispatch(setTitle('SpecialT'));
	}

	componentDidMount() {
		var body = document.getElementsByTagName("BODY")[0];
		body.classList.add("terms");
	}

	componentWillUnmount() {
		var body = document.getElementsByTagName("BODY")[0];
		body.classList.remove("terms");
	}

	agreeToTC() {
		const { User, dispatch, router, route } = this.props;
		dispatch(agreeToTermsConditions(User.uid)).then(d => {
			console.log(d);
			this.setState({ "saved": true });
			dispatch(setUser({
				terms_conditions: d.terms_conditions
			}));
		})
	}

	render() {
		return (
			<main className="main termsAndConditions" >
				{this.props.User._id ?
					(<div className="page terms mb8">
						<h5 className="primary_color center">
							Welcome to SpecialT!
					</h5>
						<p className="center quiet">Please read through and accept our terms & privacy policy to continue.</p>
						<h1>Terms of Use</h1>
						<div className="termsWrap">
							<p>
								These Terms were last updated on: [June 2018]
						</p>
							<p>
								Please read these Terms and Conditions (the “Terms”) carefully before using
								this application operated by SpecialT (Pty) Ltd (“SpecialT”, “us”, “we” or
								“our”).
						</p>
							<p>
								Users’ access to and use of the SpecialT App (the “App”) is conditional
								upon acceptance and compliance with these Terms and the Privacy Policy.
								These Terms apply to all Users and others who may access or use the App.
						</p>
							<p>
								By downloading the App, accessing the App or by clicking on the “Accept”
								button below Users agree to be bound by these Terms. If Users do not agree
								with any part of the Terms then the App may not be used or accessed.
						</p>
							<p>
								We reserve the right to modify, suspend or terminate the App at any time.
						</p>
							<p>
								<a
									href="#definitions"
								>
									1. Definitions
						    </a>
							</p>
							<p>
								<a
									href="#theapp"
								>
									2. The App
						    </a>
							</p>
							<p>
								<a
									href="#general"
								>
									3. General
						    </a>
							</p>
							<p>
								<a
									href="#account"
								>
									4. Account registration
						    </a>
							</p>
							<p>
								<a
									href="#using"
								>
									5. Using the Service
						    </a>
							</p>
							<p>
								<a
									href="#use"
								>
									6. Acceptable and lawful use of the App
						    </a>
							</p>
							<p>
								<a
									href="#payment"
								>
									7. Payment
						    </a>
							</p>
							<p>
								<a
									href="#termination"
								>
									8. Termination
						    </a>
							</p>
							<p>
								<a
									href="#int-property"
								>
									9. Intellectual Property
						    </a>
							</p>
							<p>
								<a
									href="#modifications"
								>
									10. Modifications to the App
						    </a>
							</p>
							<p>
								<a
									href="#indemnity"
								>
									11. Indemnity
						    </a>
							</p>
							<p>
								<a
									href="#limitation"
								>
									12. Limitation of liability
						    </a>
							</p>
							<p>
								<a
									href="#disclaimer"
								>
									13. Disclaimer
						    </a>
							</p>
							<p>
								<a
									href="#privacy"
								>
									14. Privacy and protection of Personal Information
						    </a>
							</p>
							<p>
								<a
									href="#changes"
								>
									15. Changes
						    </a>
							</p>
							<p>
								<a
									href="#links"
								>
									16. Links to other websites
						    </a>
							</p>
							<p>
								<a
									href="#misc"
								>
									17. Miscellaneous
						    </a>
							</p>
							<h2>
								<a name="definitions"></a>Definitions
						        </h2>
							<p>
								The following terms shall have the following meanings unless indicated
								otherwise:
						</p>
							<p>
								Guardians – shall include those authorised in writing to act as guardians
								on the App by parents in writing, such as grandparents, au pairs and even
								teachers, where applicable.
						</p>
							<p>
								HPCSA – the Health Professions Council of South Africa
						</p>
							<p>
								Parents – a child’s mother or father, or both
						</p>
							<p>
								Personal Information – any information that could identify any individual,
								including: names, email address, device identity, billing information, and
								so on.
						</p>
							<p>
								Practice Owners – the owners of the occupational therapy practices
						</p>
							<p>
								Terms – these Terms of Use
						</p>
							<p>
								Therapists – qualified occupational therapist practitioners
						</p>
							<p>
								Users – Parents, Guardians, Therapists and Practice Owners, and referred to
								as “Users”, “they”, “their”, “theirs”
						</p>
							<p>
								Each of these definitions include use of the words defined in the singular.
						</p>
							<h2>
								<a name="theapp"></a>The App
						</h2>
							<p>
								The App provides a platform for Users that is intended to enhance the
								connection and teamwork between Users. The App provides an easily
								accessible platform that enables Practice Owners to manage both their
								Practice and the Therapists in their Practice in a convenient way. The App
								consolidates record keeping by capturing internal therapy notes and
								communicating session details with parents. All notes, images and documents
								are stored online, confidentially and securely.
						</p>
							<h2>
								<a name="general"></a>General
						</h2>
							<p>
								We grant Users a non-exclusive, non-transferable, limited right to
								download, display and use the App. The App and all rights in the App remain
								our property.
						</p>
							<p>
								To use the App, Users must have internet access and a device that is
								capable of accessing the internet (including a phone, computer or other
								device).
						</p>
							<p>
								Therapists must provide us with one or more valid and accepted payment
								method and, by agreeing to these Terms, Therapists agree to pay a monthly
								subscription fee, as described below (in clause 7).
						</p>
							<p>
								Users acknowledge that we do not provide medical care, occupational therapy
								care, nursing and/or diagnostic services or function as a medical
								professional of any kind. Users acknowledge that the App cannot be used to
								request emergency care.
						</p>
							<p>
								Users agree not to interrupt or attempt to interrupt the operation of the
								App in any way. We reserve the right to restrict access to part of or to
								the entire App at any time.
						</p>
							<p>
								Users understand that problems may occur with internet connectivity. The
								availability of the internet may be disrupted by any number of things. Any
								problems with internet availability or connectivity are outside our control
								and we make no guarantee that our Services or the App will be available.
						</p>
							<p>
								Users are solely responsible for installation of the App on their devices.
								Any problems encountered while using of the App, including software ‘bugs’
								or any other system failure must be reported to us immediately.
						</p>
							<h2>
								<a name="account"></a>Account registration
				        </h2>
							<h3>
								Practice Owners and Therapists
			            </h3>
							<p>
								It is possible for Users to be registered on the App in different
								capacities. Practice Owners, for example, can be registered as both
								Therapists and Parents.
						</p>
							<p>
								Practice Owners are responsible for entering their own practice information
								upon registration, the account information for Therapists, Parents,
								Guardians, and the details of children being treated in their practice.
								Practice Owners are responsible for sharing their practice-specific URL
								with Parents, Guardians and Therapists, and for assigning children to the
								relevant Parents, Guardians and Therapists.
						</p>
							<p>
								In registering Therapists, Practice Owners are required to submit certain
								Personal Information for each Therapist in their Practice. The information
								required includes: full name, practice name, HPCSA number, phone numbers,
								email address, physical address of practice, website address, password and
								payment method. Practice Owners may also enter a background image, logo and
								description of their practice. Emails will be used to confirm the User’s
								account. (For further information on the use of Personal Information,
								please see our Privacy Policy).
						</p>
							<p>
								Practice Owners agree to provide and maintain accurate, complete and
								up-to-date information on each account. Failure to do so may result in
								automatic inability to access and use the App or termination of the licence
								to use the App.
						</p>
							<p>
								Therapists must be occupational therapists registered with the HPCSA and
								must provide a valid and active registration number from the HPCSA.
						</p>
							<p>
								Once registered on the App, both Practice Owners and Therapists are
								responsible for providing Parents with practice-specific URL links to
								access information from Therapists.
						</p>
							<p>
								If a free trial is applicable, payment will only be required upon expiry of
								the free trial.
						</p>
							<h3>
								Parents
				        </h3>
							<p>
								Once registered, each Parent will be allocated to the relevant Therapist
								and child on the App by the Practice Owner or Therapist.
						</p>
							<h3>
								All Users
				        </h3>
							<p>
								In order to open an account and to use the App, Users must be at least 18
								years of age.
						</p>
							<p>
								Users can sign on to the App using single-sign-on (SSO) services such as
								Google and Facebook.
						</p>
							<p>
								Users are responsible for all activity on their Account. Users agree to
								maintain the security and confidentiality of their username and password
								(sign on details) at all times.
						</p>
							<p>
								It is possible for Users to access the App in different capacities, but the
								App may be accessed in only one capacity at any given time.
						</p>
							<p>
								Users may not authorise third parties to use their Account.
						</p>
							<p>
								Users may not assign or transfer their Account to any other person or
								entity.
						</p>
							<p>
								Users agree to abide by the App rules and all applicable laws. Users agree
								to use the App only for lawful purposes and within South Africa.
						</p>
							<p>
								Users will not use the App or the Service in such a way as to cause
								nuisance, annoyance or property damage to another person.
						</p>
							<p>
								Users may, in certain circumstances, be required to provide proof of
								identity in order to access the App or Services. Users agree that refusal
								to do so, may mean that access to the App and Service is denied.
						</p>
							<h2>
								<a name="using"></a>Using the Service
				        </h2>
							<h3>
								Eligibility
			            </h3>
							<p>
								Users must be 18 years of age or older to access and use the App. By
								accessing and using the App, Users represent and warrant that they have the
								right, authority and capacity to abide by the Terms of Use and this Privacy
								Policy.
						</p>
							<h3>
								Practice Owners and Therapists
				        </h3>
							<p>
								There may only be one Practice Owner per practice. There may be more than
								one Therapist per practice. Each Therapist will be allocated an account of
								their own.
						</p>
							<p>
								Therapists are required to pay a monthly subscription fee. See clause 7 for
								further information.
						</p>
							<h3>
								Parents and Guardians
						        </h3>
							<p>
								Once registered, Parents and Guardians will be sent a hyperlink from the
								relevant Therapist. Each hyperlink will provide access to a particular
								child’s information and allow each Parent or Guardian to communicate with
								the relevant Therapist. Any change in Therapist for a given Patient on the
								App must comply with the applicable laws and best practice guidelines.
						</p>
							<p>
								Parents and Guardians are not required to pay for use of the App.
						</p>
							<h3>
								Communication with Therapists
						        </h3>
							<p>
								Users understand and agree that one of the purposes of the App is to create
								a more consolidated set of Patient records and communications.
						</p>
							<p>
								Users will be able to send messages by adding a comment in the space
								allocated for each session within each child’s profile. Once entered, each
								comment will be allocated the date it was entered in the App.
						</p>
							<p>
								Users are warned that use of the internet and email is not secure. While
								precautionary measures are taken by use of an SSL Certificate there is no
								guarantee that information sent via the App is safe.
						</p>
							<p>
								Parents and Guardians understand that Parent-Therapist communications are
								encrypted in transit by the use an SSL Certificate, but are not encrypted
								in storage. Messages are encrypted for storage purposes only. The full
								names of Parents and Guardians will be disclosed in messages to Therapists.
						</p>
							<p>
								Messages between Parents or Guardians and Therapists will not be vetted by
								us. We cannot be held liable for the content of messages sent by Users or
								the Therapists.
						</p>
							<p>
								Users agree to take reasonable precautions in making use of the App.
						</p>
							<h3>
								Therapists
						        </h3>
							<p>
								We do not employ the Therapists that use the App.
						</p>
							<p>
								Users acknowledge that we are not responsible in any way for the quality of
								service provided to them by a Therapist.
						</p>
							<p>
								While we do request that Therapists enter some credentials when signing up
								to use the App, we cannot guarantee the verification of degrees,
								qualifications, licensure, certificates, credentials, competence or
								background of any Therapist as accurate. Other than doing this, we do not
								vet Therapists or their sessions in any way. Parents and Guardians take
								full responsibility for the decision to use any given Therapist, and for
								the use and application of any service or advice from the Therapist.
						</p>
							<p>
								Users understand that the relationship between Parents and Guardians and
								Therapists is strictly between them. We are not involved in the therapy
								provided.
						</p>
							<p>
								Users agree, confirm and acknowledge that they are aware that the
								therapeutic advice or services that might be provided through the App are
								not a substitute for a face-to-face session with a Therapist. SpecialT
								accepts no responsibility for the application of any therapeutic or other
								advice through the platform of the App.
						</p>
							<h2>
								<a name="use"></a>Acceptable and lawful use of the App
						        </h2>
							<p>
								The App may be used only for lawful purposes. In using the App, Users agree
								to abide by all applicable laws, rules and guidelines for good practice.
						</p>
							<p>
								Users shall not use the App in such a way that:
						</p>
							<ul>
								<li>
									<p>
										introduces material that is malicious or technologically harmful;
						        </p>
								</li>
								<li>
									<p>
										is an attempt to gain unauthorised access to the App, servers,
										computer or database related to the App;
						        </p>
								</li>
								<li>
									<p>
										violates any confidentiality in respect of the content;
						        </p>
								</li>
								<li>
									<p>
										makes use of the App to collect or store personal data about other
										Users without express permission;
						        </p>
								</li>
								<li>
									<p>
										includes false or inaccurate information that is known to be false
										or inaccurate;
						        </p>
								</li>
								<li>
									<p>
										disables, circumvents or interferes with any security features of
										the App;
						        </p>
								</li>
								<li>
									<p>
										attempts to probe, scan or test the vulnerability of the App,
										associated system or network;
						        </p>
								</li>
								<li>
									<p>
										instruct or encourage any other person to do any of the above.
						        </p>
								</li>
							</ul>
							<p>
								Except as set out in these Terms, or as permitted by law, Users agree:
						</p>
							<ul>
								<li>
									<p>
										not to copy, make alterations to, or modify, the whole or any part
										of the App, or permit the App or any part of it to be incorporated
										with any other program; and
						        </p>
								</li>
								<li>
									<p>
										not to exploit the App otherwise than to the extent of the licence
										granted under these Terms.
						        </p>
								</li>
							</ul>
							<h2>
								<a name="payment"></a>Payment
						        </h2>
							<p>
								These payment terms apply to Therapists.
						</p>
							<h3>
								Fees
						        </h3>
							<p>
								Use of the App by Therapists is on a month-to-month basis and will continue
								on that basis until use is terminated. Therapists will pay the monthly
								subscription fees specified by SpecialT.
						</p>
							<h3>
								Invoicing and Payment
						        </h3>

							<p>
								Therapists will provide valid and updated credit card information, or a
								valid purchase order or alternative document acceptable to us.
						</p>
							<p>
								By providing us with credit card information, Therapists authorise us to
								charge such credit card for all monthly subscription fees monthly in
								advance.
						</p>
							<p>
								If a payment method other than a credit card is specified, the Therapists
								will be invoiced accordingly, monthly and in advance.
						</p>
							<p>
								Fees will be billed in advance, and automatically renew on a monthly basis,
								or as agreed in writing. No refunds or credits will be provided for partial
								months.
						</p>
							<h3>
								Overdue charges
						        </h3>
							<p>
								Therapists remain responsible for any uncollected amounts. If payment is
								not successfully settled due to insufficient funds or otherwise within 30
								days, we reserve the right to immediately suspend access to the App,
								effective until payment is received in full.
						</p>
							<h3>
								Right to change prices
						        </h3>
							<p>
								We may change our subscription plan/s and the subscription price from time
								to time. Any price change will be communicated on our website and on the
								App. Continued use of the App by Therapists after changes in price
								constitutes an acceptance of the new price. Any changes will apply no
								earlier than 30 days following notice to Therapists.
						</p>
							<h2>
								<a name="termination"></a>Termination
						        </h2>
							<p>
								Users can terminate their subscription at any time. Users will continue to
								have access to and use of the App through to the end of their monthly
								billing period, where applicable.
						</p>
							<p>
								Users may terminate their account and use of the App by submitting a
						termination request to us by email    <a href="mailto:info@specialt.co.za">info@specialt.co.za</a> or by calling
									us on 064 528 3195.
						</p>
							<p>
								Upon termination, Users will have access to and use of existing content
								only. No further communications will be permitted between Users. No further
								information may be stored on the App.
						</p>
							<p>
								We reserve the right, in our sole discretion, to
								terminate the right to access or use of the App. To the
								extent permitted by the Consumer Protection Act and
								other applicable legislation, we are not responsible
								for any loss, harm or damage related to Users’
								inability to access or use the App as a result of
								termination.
	                    </p>

							<h2>
								<a name="int-prop"></a>Intellectual Property
						        </h2>
							<h3>
								SpecialT
						            </h3>
							<p>
								Users agree that we retain all rights, title and interest in and to all
								copyright, trade marks, trade secrets, and any other proprietary rights in
								the App, the software, App interfaces, and videos used on the App. Users
								may not reverse engineer, reverse compile or otherwise reduce to human
								readable form any software associated with the App.
						</p>
							<p>
								No portion of the App may be reproduced in any way except as may be
								expressly permitted in these Terms. Users agree not to exploit the App in
								any unauthorised manner.
						</p>
							<h3>
								User Content
						        </h3>

							<p>
								When Users use the App, Users may store things like their files, therapy
								notes, documents, images, communicating sessions and so on on the SpecialT
								server (“User Content”). User Content belongs to Users only. We do not have
								any rights to User Content except for limited rights to enable us to
								provide the App.
						</p>
							<p>
								To provide Users with access to and use of the App, we will need to do
								things like host User Content, back it up and share it when Users ask us
								to. The App provides Users with features that preview documents, organise
								communications, editing, sharing and searching content. These and other
								features may require our systems to access, store and scan User Content.
								Users give us permission to do these things, and this permission extends to
								our affiliates and the trusted third parties we work with.
						</p>
							<h2>
								<a name="modifications"></a>Modifications to the App
						        </h2>
							<p>
								SpecialT reserves the right to modify, suspend or discontinue the App,
								either temporarily or permanently, and with or without notice to Users.
						</p>
							<h2>
								<a name="indemnity"></a>Indemnity
						        </h2>
							<p>
								To the extent permitted by law, Users shall hold SpecialT harmless against
								all costs, damages and expenses, loss and liabilities that arise as a
								direct or indirect result of any breach of these terms by you, your fault,
								negligence or breach of duty imposed by statute.
						</p>
							<h2>
								<a name="limitation"></a>Limitation of liability
						        </h2>
							<p>
								Except to the extent that liability cannot be excluded by law including the
								Consumer Protection Act, we will not be liable to Users or any other person
								for any accident, injury, loss or claim by anyone arising from use of the
								App, Service, or any content made available through the App.
						</p>
							<p>
								SpecialT cannot be held responsible for any service, advice, or
								communication provided by a Therapist.
						</p>
							<p>
								Users assume the risk in using the App as well as total responsibility for
								establishing and maintaining procedures for data backup and virus checking
								as they consider necessary.
						</p>
							<h2>
								<a name="disclaimer"></a>Disclaimer
						        </h2>
							<p>
								We do not guarantee that the App will always function without disruption,
								delay or other imperfection.
						</p>
							<p>
								We do not make any guarantees or provide any undertaking that the App will
								be available at all times; or that the App will be error free, reliable,
								secure or free from viruses or other harmful content; or that we will
								correct any defects.
						</p>
							<h2>
								<a name="privacy"></a>Privacy and protection of Personal Information
						        </h2>
							<p>
								We are committed to protecting privacy and security of Users and have
								explained the steps taken to do so. Please read our Privacy Policy [link]
						</p>
							<p>
								In order to further protect your privacy and any information stored on the
								App, we recommend that all files be password protected with a sufficiently
								secure password.
						</p>
							<h2>
								<a name="changes"></a>Changes
						        </h2>
							<p>
								These Terms and Conditions may change at any time. Users should visit this
								page periodically to check for changes.
						</p>
							<p>
								Users may be informed from time to time of any material changes to these
								Terms and Conditions with a notice that is appropriate in the
								circumstances, for example: by displaying a prominent notice or by sending
								Users an email.
						</p>
							<p>
								Where changes are made, continued use of the App by Users constitutes
								acceptance of the changes.
						</p>
							<p>
								If Users do not wish to continue using the App under the new version of the
								Terms and Conditions, Users may terminate their account.
						</p>
							<h2>
								<a name="links"></a>Links to other websites
						        </h2>
							<p>
								The App and the content stored on the App may contain links to other
								websites that are not under our control. The inclusion of such a link is
								not an endorsement by us of the site and we are not responsible for the
								content of the linked sites.
						</p>
							<h2>
								<a name="misc"></a>Miscellaneous
						        </h2>
							<h3>
								Governing law
						            </h3>
							<p>
								These Terms and Conditions shall be governed by and interpreted in
								accordance with the laws of South Africa.
						</p>
							<h3>
								Complaints
						        </h3>
							<p>
								If Users have a complaint about the App, we can be contacted by email at support@firstview.co
						</p>
							<h3>
								Technical Support
						        </h3>
							<p>
								If Users have any technical issues with the App, please send an email to support@firstview.co with a detailed description of your issue so it can be resolved quickly and effectively.
						</p>
						</div>
						<h1>Privacy Policy</h1>
						<div className="termsWrap">
							<p>
								This Privacy Policy was last updated on 1 July 2018
						</p>
							<p>
								SpecialT (Pty) Ltd (“us”, “we”, or “our”) takes your privacy very
								seriously.
						</p>
							<p>
								This Privacy Policy explains how and why we collect personal information
								from you, how we use it, the conditions under which we may disclose it to
								others, how we keep it safe and secure and your rights in relation to your
								personal information in using the SpecialT App (the “App”).
						</p>
							<p>
								Please read through it carefully and let us know if you have any questions.
						</p>
							<p>
								This Privacy Policy forms a part of and is to be read together with the
								Terms of Use.
						</p>
							<p>
								<a
									href="#pr-definitions"
								>
									1. Definitions
						    </a>
							</p>
							<p>
								<a
									href="#pr-info"
								>
									2. What information we collect on the App
						    </a>
							</p>
							<p>
								<a
									href="#pr-access"
								>
									3. Who has access to Personal Information?
						    </a>
							</p>
							<p>
								<a
									href="#pr-howwhy"
								>
									4. How and why is your information used?
						    </a>
							</p>
							<p>
								<a
									href="#pr-cookies"
								>
									5. Cookies
						    </a>
							</p>
							<p>
								<a
									href="#pr-third"
								>
									6. Is information collected by or used by third parties?
						    </a>
							</p>
							<p>
								<a
									href="#pr-consent"
								>
									7. Consent
						    </a>
							</p>
							<p>
								<a
									href="#pr-limiting"
								>
									8. Limiting use, disclosure and retention
						    </a>
							</p>
							<p>
								<a
									href="#pr-safeguards"
								>
									9. Safeguards
						    </a>
							</p>
							<p>
								<a
									href="#pr-rights"
								>
									10. What rights do you have?
						    </a>
							</p>
							<p>
								<a
									href="#pr-privacy">
									11. How will you be notified of changes to our privacy policy?
						    </a>
							</p>
							<p>
								<a
									href="#pr-contact"
								>
									12. Contact details
						    </a>
							</p>
							<h2>
								<a name="pr-definitions"></a>Definitions
				        </h2>
							<p>
								The following terms shall have the following meanings unless indicated
								otherwise:
						</p>
							<p>
								Guardians – shall include those authorised in writing to act as guardians
								on the App by parents in writing, such as grandparents, au pairs and even
								teachers, where applicable.
						</p>
							<p>
								HPCSA – the Health Professions Council of South Africa
						</p>
							<p>
								Parents – a child’s mother or father, or both
						</p>
							<p>
								Personal Information – any information that could identify any individual,
								including: names, email address, device ID, billing information, and so on.
						</p>
							<p>
								Practice Owners – the owners of the occupational therapy practices
						</p>
							<p>
								Therapists – qualified occupational therapist practitioners
						</p>
							<p>
								Users – Practice Owners, Therapists, Parents and Guardians, and referred to
								as “Users”, “you”, “your”
						</p>
							<p>
								Each of these definitions include use of the words defined in the singular.
						</p>
							<h2>
								<a name="pr-info"></a>What information we collect on the App
				        </h2>

							<p>
								Information may be collected from Users directly, or through use of the
								App.
						</p>
							<h3>
								Personal Information
				        </h3>
							<h4>
								Information provided to us directly or through third parties
			            </h4>
							<p>
								When Users register with us and use the App, we are provided with Personal
								Information. This Personal Information can be used to identify Users.
						</p>
							<p>
								Once registered, all Users will be required to log on to the App using a
								third party social networking or integrated service (we call them
								“integrated services”), such as Google and Facebook (third parties). These
								integrated services will allow the third parties to authenticate the
								identity of Users and provide the option to share certain Personal
								Information with us like names and email addresses.
						</p>
							<p>
								If Users connect to the App through Facebook or Google, the information we
								may access, collect and store may include the following, among other
								information allowed by you: your name; your profile picture; your email
								address; and basic profile information.
						</p>
							<p>
								If you connect using Facebook or using your Google account, your profile
								photo may, depending on your privacy settings, be used by the App. Facebook
								status updates are never recorded and nor does any human have access to
								them. If you connect using your Google account, the system will not be able to access your
								Gmail email messages. Your email text is never recorded, nor does any human have access to the emails. Profile photos are
								only seen by other Users.
						</p>
							<h4>
								Practice Owners and Therapists
				        </h4>
							<p>
								In creating an account for a practice, Practice Owners will need to provide
								the following information for Therapists in their practice:
						</p>
							<ul>
								<li>
									<p>
										full name;
						        </p>
								</li>
								<li>
									<p>
										practice name;
						        </p>
								</li>
								<li>
									<p>
										HPCSA number;
						        </p>
								</li>
								<li>
									<p>
										phone numbers (landline and cell);
						        </p>
								</li>
								<li>
									<p>
										email address;
						        </p>
								</li>
								<li>
									<p>
										physical address of practice;
						        </p>
								</li>
								<li>
									<p>
										website address; and
						        </p>
								</li>
								<li>
									<p>
										password.
						        </p>
								</li>
							</ul>
							<p>
								Practice Owners may choose to provide the following optional information:
						</p>
							<ul>
								<li>
									<p>
										company logo;
						        </p>
								</li>
								<li>
									<p>
										background image; and
						        </p>
								</li>
								<li>
									<p>
										a brief description of the practice.
						        </p>
								</li>
							</ul>
							<p>
								Emails will be used to confirm the activation of each User’s account.
						</p>
							<p>
								Information such as credit card, bank account details and other identity
								details will be collected directly from Therapists, stored and shared as
								necessary for the purpose of collecting payment. All payment information is
								stored within a secure vault.
						</p>
							<h4>
								Therapists, Parents and Guardians
				        </h4>
							<p>
								Once registered by Practice Owners, Therapists, Parents and Guardians will
								be required to log on using an integrated service.
						</p>
							<p>
								Parents are required to give written consent before Guardians may be
								recorded on the App.
						</p>
							<h3>
								Personal Information of children
				        </h3>
							<p>
								Persons under the age of 18 are not permitted to create, access or use the
								App. We do not knowingly collect information from children.
						</p>
							<p>
								Parents are required to consent to the entry of a child’s information on
								the App and to continued use of the App. Parents may withdraw consent at
								any time.
						</p>
							<p>
								Any information about children that is collected by Practice Owners and
								Therapists, including name, date of birth and any other information is
								stored in an encrypted manner on our servers and protected from
								unauthorised disclosure.
						</p>
							<p>
								Upon receipt of the relevant consent, each child’s name and surname will be
								entered on the App by the relevant Practice Owner. Each child will then be
								allocated to the relevant Therapist and may be assigned to a Parent or
								Guardian on the App.
						</p>
							<p>
								Details of the child’s diagnosis, Therapist recommendations, as well as any
								sessions, past and future, may be recorded on the App by the Therapist.
								Notes may be recorded by the Therapist for each session. Therapists may
								assign exercises for the child to practice and videos for these can be
								accessed via the App by Parents and Guardians.
						</p>
							<p>
								Parents and Guardians will have access to the notes, pictures and videos
								allocated specifically to them on the App. Feedback on the activities
								practiced at home can be provided to the Therapist via the App in the
								comment section within each session under the child’s profile.
						</p>
							<p>
								We do not collect any Personal Information about children. We may collect
								information about children that does not identify them personally using
								software like Google Analytics for the purposes of research. This
								non-identifying information includes: the number of sessions attended and
								how long a child has been in therapy.
						</p>
							<h3>
								Information collected from your use of the App
				        </h3>
							<p>
								Information may also be collected passively through the App. This
								information is mostly not personally identifying information. This is the
								kind of information that web browsers, servers and services like Google
								Analytics make available, like the browser type, language preference, time
								of each visit, and the number of times a button is clicked or a video is
								accessed. Other non-identifying information we might have access to
								includes how you use the App, your location, cookies, etc.
						</p>
							<h2>
								<a name="pr-access"></a>Who has access to Personal Information?
				        </h2>
							<p>
								We do not sell or rent your information to third parties. We do not share
								your information with third parties for marketing information. However, we
								may share your information with third parties in order to achieve the
								purposes of the App, as set out in this policy.
						</p>
							<h3>
								Users
				        </h3>
							<p>
								The Personal Information and the information (together referred to as
								“information” in this paragraph) stored on the App is confidential.
						</p>
							<p>
								Consent must be obtained from Users before any Personal Information may be
								collected and stored on the App.
						</p>
							<p>
								Parents and Guardians may only access the information that pertains to
								their children. The access granted to Parents and Guardians is limited to
								the notes entered by them, the therapy areas that have been or are being
								worked on and the videos recommended by the Therapist.
						</p>
							<p>
								Each Therapist is granted access to all the information entered on the App
								by them. Therapists may only access information where the information was
								entered in relation to their treatment of a child. Any information entered
								by another Therapist in relation to the treatment of the same child may not
								be accessed by a different Therapist, unless an exception applies.
						</p>
							<p>
								Where a Therapist makes notes in treating a child, those notes may only be
								accessed by that Therapist and the relevant Practice Owner.
						</p>
							<p>
								Practice Owners have limited access to Personal Information. Practice
								Owners may access the list of Therapists, Parents and children in their
								practice. Practice Owners have access to the names and contact details of
								all Users in their practice. Where Practice Owners use the App in their
								capacity as Therapists, the rules pertaining to the access to information
								of Therapists will apply to them.
						</p>
							<h3>
								SpecialT
				        </h3>
							<p>
								Your information is restricted. We will only access it at your written
								request or in the case where we need to debug and solve problems. All such
								access is closely monitored.
						</p>
							<p>
								We do not sell or rent your information to third parties. Nor do we share
								your information with third parties for the purpose of marketing. We may,
								however, share your information with third parties for the purposes of
								achieving other purposes, including the purposes of this Privacy Policy.
						</p>
							<p>
								Some of the functionalities of the App interoperate with and are dependent
								on the applications of third parties like Google and Facebook. We may
								collect Personal Information from these third parties to the extent that
								you authorise us to do so. The collection, use and disclosure of that
								Personal Information will be governed by this Privacy Policy. Where no
								other authorisations are provided, we will have access to the names and
								email addresses of Users.
						</p>
							<p>
								In addition, if Users authorise us to do so, and to the extent
								authorisation is provided, we may grant third parties access to Personal
								Information. Users may control what Personal Information is shared with
								third parties. Any Personal Information shared by Users with third parties
								will be governed by the third party privacy policies and we do not assume
								any responsibility for the use of Personal Information by third parties
								once it has been shared.
						</p>
							<p>
								The third parties providing payment services we use will collect all
								information necessary to complete the transaction, including Users’ names,
								credit card information, billing information and shipping information.
								Where this information is not collected by us, the third party Privacy
								Policy will apply.
						</p>
							<p>
								If feedback is provided to us or you contact us via email, we will collect
								your name and email address, as well as the information contained in the
								email in order to provide a reply.
						</p>
							<h2>
								<a name="pr-howwhy"></a>How and why is your information used?
				        </h2>
							<p>
								We may use the information you give us (Personal Information or otherwise)
								for a number of different reasons, which include:
						</p>
							<ul>
								<li>
									<p>
										providing you with the services asked for;
						        </p>
								</li>
								<li>
									<p>
										providing you with support;
						        </p>
								</li>
								<li>
									<p>
										carrying out our obligations under any contracts entered into
										between you and us;
						        </p>
								</li>
								<li>
									<p>
										keeping a record of your relationship with us;
						        </p>
								</li>
								<li>
									<p>
										conducting analysis and market research so that we can improve our
										services or information;
						        </p>
								</li>
								<li>
									<p>
										asking you for your feedback on the services we provide;
						        </p>
								</li>
								<li>
									<p>
										conducting research (where personal information is de-identified);
						        </p>
								</li>
								<li>
									<p>
										notifying you of changes to our services; and
						        </p>
								</li>
								<li>
									<p>
										sending you any communications requested by you (which may include
										marketing where you have consented).
						        </p>
								</li>
							</ul>
							<p>
								Any research conducted is for the purposes of the improvement of the App,
								to determine the levels of parent-therapist engagement, and to determine
								the effectiveness of therapy.
						</p>
							<h2>
								<a name="pr-cookies"></a>Cookies
				        </h2>
							<p>
								Technologies like cookies are used by us and our analytics service
								providers (like Google Analytics) and affiliates to analyse usage trends,
								and administer the App.
						</p>
							<p>
								A cookie is a piece of information that the App sends to your browser,
								which may then be stored on your device so that we recognise you when you
								return. We use cookies to collect information in order to improve the App.
								Cookies let us know who you are, they are necessary to access your account
								and will give us information that we can use to personalise the App
								according to your preferences.
						</p>
							<p>
								We collect technical information such as: unique identifiers, user
								preferences, general usage, and volume information. We also use third-party
								analytical cookies for tracking web traffic and usage.
						</p>
							<p>
								You can control the use of cookies from your browser. If you disable
								cookies, certain functionalities on the App or access to your account may
								be lost.
						</p>
							<h2>
								<a name="pr-third"></a>Is information collected by or used by third parties?
				        </h2>
							<p>
								If you authorise us to do so, we may grant third parties access to Personal
								Information (depending on the authorisation given) for use in connection
								with third party services. You are able to control what information is
								shared with third parties. However, any Personal Information shared with
								third parties is governed by third party privacy policies and we do not
								assume any responsibility for use of the Personal Information shared with
								third parties through the App.
						</p>
							<p>
								We will not share the Personal Information of children with third parties.
						</p>
							<p>
								Information may be disclosed to third parties as required by law and when
								we believe it is necessary.
						</p>
							<p>
								You are able to adjust your settings to reflect your preferences.
						</p>

							<h3>
								Credit or debit card information
				        </h3>
							<p>
								We may work with a third-party payment processor such as Payfast or Paygate to manage and
								process payments in order to guarantee the security of information.
						</p>

							<h2>
								<a name="pr-consent"></a>Consent
				        </h2>

							<h3>
								Submitting the Personal Information of others
			            </h3>
							<p>
								Practice Owners and Therapists are responsible for informing Parents and
								Guardians about the App and for obtaining the necessary consent or
								authority from Parents and Guardians to save the Personal Information of
								children on our servers.
						</p>

							<h3>
								Closing your account with us
				        </h3>

							<p>
								At any time and without penalty, you can withdraw consent to the continued
								use or disclosure of Personal Information by closing your account with us.
						</p>
							<p>
								Your account will be closed one calendar month from the date we receive
								notification of cancellation in writing.
						</p>
							<p>
								You are to ensure that the process has been completed in order for the
								account to be closed. This includes the receipt of a confirmation email.
						</p>

							<h3>
								Email and communications consent
				        </h3>

							<p>
								You can opt-out of commercial email communications from us at any time by
								clicking on the unsubscribe link in emails, or by email request to us.
								Certain non-commercial communications may still be sent to you, such as
								system notifications, major product changes, changes to our Terms of Use,
								or other news that we believe will materially affect how you interact with
								us.
						</p>
							<p>
								The only way for you to completely stop all emails from us is to close your
								account.
						</p>

							<h2>
								<a name="pr-limiting"></a>Limiting use, disclosure and retention
				        </h2>

							<p>
								We only collect the Personal Information that is necessary to provide you
								with access to and use of the App.
						</p>
							<p>
								We may share Personal Information only as described in this policy.
						</p>
							<p>
								We may use third party services to supplement or improve our understanding
								of you. This may mean cross-referencing information we have with the
								databases of third parties in order to do so.
						</p>
							<p>
								We keep your Personal Information for no longer than is necessary for the
								purposes it was collected. We may be required to keep even after your
								account is terminated. Any information that is no longer in use will be
								archived until it may be deleted. The purposes and length of retention are
								determined by the type of data concerned, the purpose/s for which it is
								processed, and the applicable laws, including those of the HPCSA.
								Therapists are required to keep medical records until the child reaches the
								age of 18 years or, in certain circumstances, for life.
						</p>
							<h2>
								<a name="pr-safeguards"></a>Safeguards
				        </h2>
							<h3>
								How do we protect information?
			            </h3>
							<p>
								We use a combination of appropriate safeguards to protect your Personal
								Information. This includes appropriate technical and organisation controls.
						</p>
							<p>
								All sensitive information is protected by encryption via SSL on our servers and by the third parties providing payment services.
						</p>
							<p>
								All data is encrypted via an ssl certificate when transmitted
								from our servers to your browser and/or the App. The database backups are
								also encrypted.
						</p>
							<p>
								Data is not encrypted while it is live in our database. This is because it
								needs to be available to you when you need it. Our
								database and access to the App is secured through the use of passwords,
								automatic logouts, automatic logging of access, data back-ups, powerful
								firewalls, and limiting access to only those who absolutely need it.
						</p>
							<p>
								No Practice Owners or any employee of SpecialT will contact you by email or
								using the SpecialT messaging system asking for a User’s login details,
								password or any other Personal Information related or unrelated to the App
								or SpecialT. If any message claiming or appearing to come from SpecialT or
								its website is sent to you asking for such information, we request that it
						be reported immediately to    <a href="mailto:info@specialt.co.za">info@specialt.co.za</a>.
						</p>

							<h3>
								User password
				        </h3>

							<p>
								You are responsible for maintaining the confidentiality of your password
								and login details. You are fully responsible for all activities that occur
								under your account with or without your knowledge.
						</p>
							<p>
								If you knowingly provide your password information and/or login credentials
								to another person, your privileges as a User may be suspended temporarily
								or terminated. You agree that you will notify us immediately in the event
								of any unauthorised use of your password or login credentials or any other
								breach of security.
						</p>
							<h2>
								<a name="pr-rights"></a>What rights do you have?
				        </h2>

							<p>
								At any time, you can ask us to:
						</p>
							<ul>
								<li>
									<p>
										provide a copy of the Personal Information stored;
						        </p>
								</li>
								<li>
									<p>
										correct any mistakes in Personal Information;
						        </p>
								</li>
								<li>
									<p>
										delete Personal Information (this is subject to the requirements of
										the HPCSA);
						        </p>
								</li>
								<li>
									<p>
										restrict the processing of Personal Information in certain
										circumstances.
						        </p>
								</li>
							</ul>
							<p>
								You can object to:
						</p>
							<ul>
								<li>
									<p>
										Personal Information being processed for direct marketing (at any
										time);
						        </p>
								</li>
								<li>
									<p>
										the continued processing of Personal Information.
						        </p>
								</li>
							</ul>
							<p>
								If Users would like to exercise any of these rights we can be contacted at    <a href="mailto:info@specialt.co.za">info@specialt.co.za</a>.
						</p>
							<p>
								Please note that the exercise of any of these rights may affect our ability
								to provide access to and use of the App. We will let Users know where this
								is the case. There are also circumstances where we may be required or
								permitted by law to continue processing Personal Information even where
								consent has been withdrawn.
						</p>

							<h2>
								<a name="pr-privacy"></a>How will you be notified of changes to our privacy policy?
				        </h2>

							<p>
								We may update this privacy policy. If we make material changes, we will
								notify you by email using the email address specified in your account or by
								a notification on our website prior to the change becoming effective. We
								encourage you to make a practice of reviewing the Privacy Policy to stay up
								to date on our privacy practices.
						</p>

							<h2>
								<a name="pr-contact"></a>Contact details
				        </h2>

							<p>
								Users can contact us at:
						</p>
							<p>
								Email: <a href="mailto:info@specialt.co.za">info@specialt.co.za</a>
							</p>
							<p>
								Phone: 064 528 3195
						</p>
							<div>
								<br />
							</div>
						</div>



						<div className="btnWrap">
							<button disabled={this.state.saved} className="md-button md-primary right link" style={saveStyle} onClick={this.agreeToTC} > Agree to Terms & Conditions </button>
						</div>


					</div>) :
					(<div>Redirecting ...</div>)}
			</main>)
	}
}

export default withRouter(terms_conditions);


// WEBPACK FOOTER //
// ./src/components/terms_conditions/terms_conditions.jsx